import React, { useEffect, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Slider from "@material-ui/core/Slider";
import Input from "@material-ui/core/Input";

export default function SliderHome(props) {
  const [color, setColor] = useState("black");
  const [value, setValue] = React.useState(Number(props.value));
  const PrettoSlider = withStyles({
    root: {
      color: color,
      height: 8,
    },
    thumb: {
      height: 24,
      width: 24,
      backgroundColor: "#fff",
      border: "2px solid currentColor",
      marginTop: -8,
      marginLeft: -12,
      "&:focus, &:hover, &$active": {
        boxShadow: "inherit",
      },
    },
    active: {},
    valueLabel: {
      left: "calc(-50% + 4px)",
    },
    track: {
      height: 8,
      borderRadius: 4,
    },
    rail: {
      height: 8,
      borderRadius: 4,
    },
  })(Slider);
  useEffect(() => {
    if (value - props.min <= (props.max - props.min) / 3) {
      setColor("red");
    } else if (value - props.min <= ((props.max - props.min) * 2) / 3) {
      setColor("#f57c00");
    } else {
      setColor("green");
    }
  }, [value]);

  const useStyles = makeStyles({
    root: {
      width: "90%",
      color: color,
    },
    input: {
      width: 42,
    },
  });

  const classes = useStyles();

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs>
          <PrettoSlider
            min={Number(props.min)}
            max={Number(props.max)}
            defaultValue={value}
            value={typeof value === "number" ? value : 0}
            onChange={handleSliderChange}
            aria-labelledby="input-slider"
          />
        </Grid>
        <Grid item>
          {value}
          {props.data_type}
        </Grid>
      </Grid>
    </div>
  );
}
